import React from "react";

const Products = () => {
  return <div>Products Page</div>;
};

export default Products;
